export default function validate(values) {
  const { nationalityId } = values;

  return {
    nationalityId: !nationalityId && 'NIK tidak boleh kosong' || nationalityId.length < 16 && 'NIK harus terdiri dari 16 digit',
  };
}
